var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","disabled":_vm.naoPodeAtestar},on:{"click":function($event){return _vm.confirmarAtesto()}}},[_c('i',{staticClass:"fa fa-check-circle-o"}),_vm._v(" Atesto")])
}
var staticRenderFns = []

export { render, staticRenderFns }